import type { PropsWithChildren } from 'react'

export const PublicLayout = ({ children }: PropsWithChildren) => (
  <div className="flex h-screen items-center">
    <div className="login-wrapper">{children}</div>
  </div>
)
